(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7266],{

/***/ 42348:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(21078);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */
function flattenDeep(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, INFINITY) : [];
}

module.exports = flattenDeep;


/***/ }),

/***/ 40076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _packages_justo_parts_lib_components_Button_withoutLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76350);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var WrappedButton = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_packages_justo_parts_lib_components_Button_withoutLink__WEBPACK_IMPORTED_MODULE_2__["default"], _objectSpread({}, props, {
        ref: ref
    }));
});
WrappedButton.displayName = "WrappedButton";
/* harmony default export */ __webpack_exports__["Z"] = (WrappedButton);


/***/ }),

/***/ 47266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DeliveryZone; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Button/index.tsx
var Button = __webpack_require__(40076);
// EXTERNAL MODULE: ./src/components/SuspenseLoading/Loading.tsx
var Loading = __webpack_require__(53762);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
// EXTERNAL MODULE: ./src/providers/apollo/getClient.ts
var apollo_getClient = __webpack_require__(98751);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/data/queries/components/deliveryZone.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query getStoresZonesComponent_cached($websiteId: ID) {\n    stores(websiteId: $websiteId) {\n      items {\n        _id\n        name\n        acceptDelivery\n        zones {\n          _id\n          deliveryLimits\n        }\n        address {\n          placeId\n          location\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var deliveryZonesQuery = (0,lib["default"])(_templateObject());
function getStoreZones(websiteId) {
    return _getStoreZones.apply(this, arguments);
};
function _getStoreZones() {
    _getStoreZones = _asyncToGenerator(regeneratorRuntime.mark(function _callee(websiteId) {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return getClient().query({
                        query: deliveryZonesQuery,
                        variables: {
                            websiteId: websiteId
                        }
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data.stores);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getStoreZones.apply(this, arguments);
}

// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
// EXTERNAL MODULE: ./src/helpers/router/getPathname.ts
var getPathname = __webpack_require__(48024);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/Container/index.js
var Container = __webpack_require__(59848);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/lodash/flattenDeep.js
var flattenDeep = __webpack_require__(42348);
var flattenDeep_default = /*#__PURE__*/__webpack_require__.n(flattenDeep);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/componentTypes/DeliveryZone/Leaflet/index.ts

// es importante cargarlo así por que Leaflet no funciona correctamente con ssr.
var Map = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9269), __webpack_require__.e(127), __webpack_require__.e(9298)]).then(__webpack_require__.bind(__webpack_require__, 87207));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(87207)
            ];
        }
    },
    ssr: false
});
/* harmony default export */ var Leaflet = (Map);

// EXTERNAL MODULE: ./src/components/componentTypes/DeliveryZone/styles.module.css
var styles_module = __webpack_require__(52325);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/componentTypes/DeliveryZone/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}















function DeliveryZone(props) {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(![
        "/",
        "/pedir",
        "/checkout"
    ].includes((0,getPathname/* default */.Z)(router))), show = ref[0], setShow = ref[1];
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var ref1 = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: deliveryZonesQuery,
        variables: {
            websiteId: websiteId
        },
        omit: (0,isServerSide/* default */.Z)(),
        partial: true
    }), queriedStores = ref1.stores;
    var stores = queriedStores ? queriedStores : props.ssrStores;
    if ((0,isServerSide/* default */.Z)() && !props.ssrStores) {
        console.warn("Could not fetch stores while doing SSR. This should be fixed for an optimized experience");
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {});
    }
    var getStores = function() {
        if (!stores) return [];
        return stores.items.filter(function(store) {
            return store.acceptDelivery;
        }).filter(function(store) {
            return store.address && store.address.location;
        });
    };
    var getPoints = function() {
        return flattenDeep_default()(getStores().map(function(store) {
            return store.zones.map(function(zone) {
                return zone.deliveryLimits;
            });
        }));
    };
    var getCenter = function() {
        var count = getStores().length;
        return getStores().reduce(function(last, store) {
            var lat = store.address.location.lat / count;
            var lng = store.address.location.lng / count;
            return {
                lat: last.lat + lat,
                lng: last.lng + lng
            };
        }, {
            lat: 0,
            lng: 0
        });
    };
    if (!stores) return null;
    if (!getStores().length) return null;
    var mapProps = {
        iconURL: props.icon,
        color: props.color,
        center: getCenter(),
        getStores: getStores,
        getPoints: getPoints
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).title,
                    children: "Cobertura del despacho"
                }),
                show ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Leaflet, _objectSpread({}, mapProps)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    onClick: function() {
                        return setShow(true);
                    },
                    children: "Mostrar mapa"
                })
            ]
        })
    });
};


/***/ }),

/***/ 52325:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1J0gAw6l4qI5eqFTbvmEsa","title":"T5VvXcyQ3OPSJlNRLOFCo appSubtitle"};

/***/ })

}]);